import { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

const TOAST_OPTIONS = {
  style: {
    background: 'var(--surface-2)',
    color: 'var(--text)',
    border: '1px solid var(--border)',
    borderRadius: '12px',
    fontSize: '14px',
    boxShadow: 'var(--shadow-raised)',
  },
  success: {
    iconTheme: {
      primary: 'var(--g-500)',
      secondary: 'var(--surface-2)',
    },
  },
  error: {
    iconTheme: {
      primary: 'var(--err)',
      secondary: 'var(--surface-2)',
    },
  },
};

export default function AppToaster() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 640);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 639px)');
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return (
    <Toaster
      position={isMobile ? 'top-center' : 'top-right'}
      containerStyle={{
        top: '64px',
        ...(isMobile ? { left: '16px', right: '16px' } : {}),
      }}
      toastOptions={{
        ...TOAST_OPTIONS,
        style: {
          ...TOAST_OPTIONS.style,
          ...(isMobile ? { width: '100%' } : {}),
        },
      }}
    />
  );
}
